define.alias("shared/components/shared/media/filter/filter-profile", "settings/components/shared/media/filter/filter-profile");